import { Link } from "react-router-dom";
import { Star, BadgeCheck } from "lucide-react";
import { useT } from "@/lib/i18n";
import { useApi, useCatalog } from "@/lib/data";
import { fileUrl } from "@/lib/api";
import { CategoryIcon } from "@/lib/icons";
import { themeOf } from "@/lib/themes";

const FeaturedCard = ({ b }) => {
  const { tn, lp } = useT();
  const { catById, locById } = useCatalog();
  const cat = catById[b.category_id];
  const th = themeOf(b.theme);
  return (
    <Link to={lp(b.slug ? `/s/${b.slug}` : `/b/${b.id}`)} data-testid={`featured-card-${b.id}`}
      className="group relative block h-52 w-64 flex-shrink-0 snap-start overflow-hidden rounded-2xl text-white shadow-sm md:w-auto"
      style={{ backgroundColor: th.main }}>
      {b.photos?.[0] ? <img src={fileUrl(b.photos[0], 800)} alt={b.name} loading="lazy" decoding="async" className="absolute inset-0 h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
        : <CategoryIcon name={cat?.icon} className="absolute right-4 top-4 h-14 w-14 opacity-30" />}
      <div className="absolute inset-0" style={{ background: `linear-gradient(to top, ${th.deep} 5%, ${th.deep}aa 40%, transparent 80%)` }} />
      <div className="absolute inset-x-0 bottom-0 p-4">
        <BadgeCheck className="h-5 w-5 text-emerald-300" />
        <p className="mt-1 line-clamp-2 font-display text-lg font-extrabold leading-tight">{b.name}</p>
        <p className="mt-0.5 truncate text-xs text-white/80">{tn(cat?.name)} · {tn(locById[b.locality_id]?.name)}</p>
        {b.rating_count > 0 && <p className="mt-1 flex items-center gap-1 text-xs font-bold"><Star className="h-3.5 w-3.5 fill-amber-300 text-amber-300" />{b.rating_avg.toFixed(1)} ({b.rating_count})</p>}
      </div>
    </Link>
  );
};

export default function FeaturedStrip({ town = "" }) {
  const { t } = useT();
  const { data = [] } = useApi(["featured", town], `/featured?town=${town}`);
  if (!data.length) return null;
  return (
    <section className="pt-7 lg:pt-10" data-testid="featured-strip">
      <div className="px-5 lg:px-8">
        <h2 className="text-base font-bold text-ink md:text-lg">{t("featured_title")}</h2>
        <p className="text-xs text-slate-500">{t("featured_sub")}</p>
      </div>
      <div className="no-scrollbar mt-3 flex snap-x gap-3 overflow-x-auto px-5 md:grid md:grid-cols-3 md:overflow-visible lg:grid-cols-4 lg:px-8">
        {data.map((b) => <FeaturedCard key={b.id} b={b} />)}
      </div>
    </section>
  );
}
